import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import NavbarNEW from "./NavbarNEW";


export default function GuestLayout() {
  const userState = useSelector((store) => store.auth);

  return (
    <div className="guestLayout">
      <NavbarNEW isAuth={!!userState?.user} />

      <Outlet />
    </div>
  );
}
